import { contactInfo } from '@/mocks/homeData';

export default function Reservation() {
  return (
    <section id="reservation" className="relative overflow-hidden py-20 md:py-28">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Dark%20luxurious%20restaurant%20dining%20room%20with%20candlelit%20tables%20and%20warm%20golden%20bokeh%20lighting%2C%20elegant%20fine%20dining%20ambiance%2C%20deep%20charcoal%20tones%20with%20gold%20accents%2C%20cinematic%20restaurant%20photography&width=1600&height=900&seq=berties-reservation-bg&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-background-50/85"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="flex items-center justify-center gap-3 mb-4">
          <span className="h-px w-12 bg-primary-500/50"></span>
          <span className="text-primary-500">◆</span>
          <span className="h-px w-12 bg-primary-500/50"></span>
        </div>
        <span className="text-xs uppercase tracking-[0.3em] text-primary-500/90">Join Us</span>
        <h2 className="font-heading text-4xl md:text-5xl font-semibold text-foreground-50 mt-4">
          Reserve Your Table
        </h2>
        <div className="flex items-center justify-center gap-3 my-6">
          <span className="h-px w-12 bg-primary-500/50"></span>
          <span className="text-primary-500">✦</span>
          <span className="h-px w-12 bg-primary-500/50"></span>
        </div>
        <p className="text-foreground-200/80 text-sm md:text-base max-w-xl mx-auto">
          Secure your dining experience at Bertie&rsquo;s. We look forward to welcoming you.
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {contactInfo.hours.map((h) => (
            <div key={h.day} className="bg-background-100/80 border border-primary-500/25 rounded-lg p-5">
              <p className="text-xs uppercase tracking-[0.2em] text-primary-500/90">{h.day}</p>
              <p className="mt-2 text-base font-medium text-foreground-50 tabular-nums">{h.time}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="whitespace-nowrap text-sm font-semibold px-8 py-3.5 rounded-full text-background-950 bg-primary-500 hover:bg-primary-400 transition-colors"
          >
            Book Online
          </a>
          <a
            href={contactInfo.phoneHref}
            className="whitespace-nowrap text-sm font-semibold px-8 py-3.5 rounded-full text-foreground-50 border border-primary-500/60 hover:border-primary-500 hover:text-primary-500 transition-colors"
          >
            Call {contactInfo.phone}
          </a>
        </div>
      </div>
    </section>
  );
}